import React, { useState, useEffect } from 'react';
import gql from 'graphql-tag';
import { GetEmployeeDetails } from 'src/_shared/api/graphql/custom/users/getEmployeeDetailsGraphql';
import { updateUser } from 'src/_shared/api/graphql/custom/users/updateUserGraphql';
import EmployeeDetailsModal from './EmployeeDetailsModal';

const EmployeeDetailsModalContainer = ({ employeeId, visible, onCancel, client, currentUser, departments, userGroups }) => {
  const [loading, setLoading] = useState(false);
  const [userData, setUserData] = useState(null);
  const [error, setError] = useState(null);

  // Fetch employee data when the modal becomes visible or employeeId changes
  useEffect(() => {
    let isMounted = true;
    
    const fetchEmployeeData = async () => {
      if (!employeeId || !visible) return;
      
      setLoading(true);
      setError(null);
      
      try {
        console.log('Fetching employee data for ID:', employeeId);
        const { data } = await client.query({
          query: gql(GetEmployeeDetails),
          variables: { id: employeeId },
          fetchPolicy: 'network-only', // Don't use cache to ensure fresh data
        });
        
        if (isMounted) {
          console.log('Employee data fetched:', data.getUser);
          setUserData(data.getUser);
          setLoading(false);
        }
      } catch (err) {
        console.error('Error fetching employee data:', err);
        if (isMounted) {
          setError(err);
          setLoading(false);
        }
      }
    };
    
    fetchEmployeeData();
    
    return () => {
      isMounted = false;
    };
  }, [employeeId, visible, client]);

  // Handle updating employee data
  const handleUpdateEmployee = async (input) => {
    setLoading(true);
    try {
      console.log('Updating employee data:', input);
      const { data } = await client.mutate({
        mutation: gql(updateUser),
        variables: { input },
      });
      
      console.log('Update result:', data);
      
      // Update local state with the new data
      setUserData(prev => ({
        ...prev,
        ...input.input
      }));
      
      setLoading(false);
      return data;
    } catch (err) {
      console.error('Error updating employee:', err);
      setError(err);
      setLoading(false);
      throw err;
    }
  };

  // Don't render anything if not visible
  if (!visible) return null;
  
  return (
    <EmployeeDetailsModal
      visible={visible}
      onCancel={onCancel}
      employeeId={employeeId}
      user={userData}
      onUpdate={handleUpdateEmployee}
      loading={loading}
      error={error}
      currentUser={currentUser}
      departments={departments}
      userGroups={userGroups}
    />
  );
};

export default EmployeeDetailsModalContainer;